angular.module( 'acme.view.application.settings.integration.logs.modals.view', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.settings.integration.logs.modals.view.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var settingsIntegrationLogsModalsView = {
        name: 'application.settings.integration.logs.modals.view',
        url: '/settings/integration/logs/modals/view',
        views: {
          "main": {
            controller: 'SettingsIntegrationLogsModalsViewController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/settings/integration/logs/modals/view/view.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(settingsIntegrationLogsModalsView);
});
